import { Module } from 'vuex-smart-module';
import StaffActions from './actions';
import StaffGetters from './getters';
import StaffMutations from './mutations';
import StaffState from './state';
import StaffDetailModule from './modules/staff-detail';
import StaffCertificatesListModule from './modules/staff-certificates-list';
import StaffAnalyticsListModule from './modules/staff-analitycs-list';

export default new Module({
  state: StaffState,
  mutations: StaffMutations,
  actions: StaffActions,
  getters: StaffGetters,
  modules: {
    staff_detail: StaffDetailModule,
    staff_certificates_list: StaffCertificatesListModule,
    staff_analytics_list: StaffAnalyticsListModule,
  },
});
